module.exports = __webpack_public_path__ + "static/landing_illustration_001-6f42ddf92a754e11ee4246102ac27522.webp";